import { render, staticRenderFns } from "./cadastroOrgao.vue?vue&type=template&id=2ab3e850"
import script from "./cadastroOrgao.vue?vue&type=script&lang=js"
export * from "./cadastroOrgao.vue?vue&type=script&lang=js"
import style0 from "./cadastroOrgao.vue?vue&type=style&index=0&id=2ab3e850&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports